/*
 * @Description: 
 * @Author: xiaoyao
 * @since: 2019-12-24 11:37:49
 * @LastAuthor: xiaoyao
 * @lastTime: 2021-10-09 10:30:54
 */
import Vue from 'vue'
import VueStorage from 'vue-ls'
import config from '@/config/defaultSettings'

// base library
import '@/core/lazy_lib/components_use'
import Viser from 'viser-vue'
import VueCropper from 'vue-cropper'
import 'ant-design-vue/dist/antd.less'
import '@/styles/style.css'
import 'viewerjs/dist/viewer.css'
//引入水印组件
import '@/utils/directives'


// ext library
import VueClipboard from 'vue-clipboard2'
import PermissionHelper from '@/utils/helper/permission'

//解决组件中使用addEventListener监听窗口变化报出警告的问题
import 'default-passive-events'
import htmlToPdf from '@/utils/htmlToPdf'

//引入基本模板
let echarts = require('echarts/lib/echarts')

// 引入条形图等组件
require('echarts/lib/chart/pie')
require('echarts/lib/chart/bar')

// 引入提示框和title组件，图例
require('echarts/lib/component/tooltip')
require('echarts/lib/component/title')
require('echarts/lib/component/legend')
require('echarts/lib/component/grid')//图例翻译滚动

Vue.prototype.$echarts = echarts

VueClipboard.config.autoSetContainer = true

Vue.use(Viser)

Vue.use(VueStorage, config.storageOptions)
Vue.use(VueClipboard)
Vue.use(PermissionHelper)
Vue.use(VueCropper)
// 使用Vue.use()方法就会调用工具方法中的install方法
Vue.use(htmlToPdf)


// WEBPACK FOOTER //
// ./src/core/lazy_use.js